export default "__VITE_ASSET__CtlV$FVS__"